import { render, staticRenderFns } from "./BetgamePrivacy.vue?vue&type=template&id=53513234&scoped=true"
import script from "./BetgamePrivacy.vue?vue&type=script&lang=js"
export * from "./BetgamePrivacy.vue?vue&type=script&lang=js"
import style0 from "./BetgamePrivacy.vue?vue&type=style&index=0&id=53513234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53513234",
  null
  
)

export default component.exports